import React from 'react'
import { ListBulkActions } from '../../components'
import { ActionField } from '../../components/custom'

import {
  List,
  Datagrid,
  TextField,
  TextInput,
  Filter,
  FunctionField,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
} from 'react-admin'
import { formatSportKind } from '../utils'
import { sportKinds } from '../../utils/constants'

const ClubsFilters = (props) => (
  <Filter {...props}>
    <TextInput label='Название' source='name' />
    {/*TODO доделать */}
    <ReferenceInput source='city' label='Город' reference='cities'>
      <AutocompleteInput optionText='name' />
    </ReferenceInput>
    <SelectInput
      label='Вид спорта'
      source='sportKind'
      choices={[
        { id: sportKinds.fight.value, name: sportKinds.fight.text },
        { id: sportKinds.gym.value, name: sportKinds.gym.text },
        { id: sportKinds.tennis.value, name: sportKinds.tennis.text },
      ]}
    />
    <TextInput label='Адрес' source='address' />
    <TextInput label='E-mail' source='email' />
    <TextInput label='Контактный телефон' source='phone' />
    <TextInput label='Сайт' source='site' />
  </Filter>
)

const ListTournaments = (props) => {
  return (
    <List
      title='Клубы'
      {...props}
      exporter={false}
      bulkActionButtons={<ListBulkActions />}
      filters={<ClubsFilters />}
    >
      <Datagrid rowClick={'show'}>
        <TextField source='name' label='Название' />
        <TextField source='city.name' label='Город' />
        <FunctionField
          label='Вид спорта'
          render={(record) => formatSportKind(record.sportKind)}
        />
        <TextField label='Адрес' source='address' emptyText='Не указано' />
        <TextField label='E-mail' source='email' emptyText='Не указано' />
        <TextField label='Телефон' source='phone' emptyText='Не указано' />
        <TextField label='Сайт' source='site' emptyText='Не указано' />
        <TextField source='totalMembers' label='Количество участников' />
        <ActionField label='Действия' />
      </Datagrid>
    </List>
  )
}

export default ListTournaments
